import { IGetFinalReportsQuery } from "../../model/types";

export const buildExportFinalReportQuery = (
  partner_id: string | null,
  agency: string | null,
  report_month: string | null,
): Partial<IGetFinalReportsQuery> => {
  const queryParams: Partial<IGetFinalReportsQuery> = {};

  if (partner_id) queryParams.partner_id = partner_id;
  if (agency) queryParams.agency = agency;
  if (report_month) queryParams.report_month = report_month;

  return queryParams;
};
